<template>
    <Drop @drop="moveTaskOrColumn"  v-if="column.name" :class="'board-list-wrapper'">
        <Drag
            :transferData="{
                type: 'column',
                fromColumnIndex: columnIndex
              }"
            :class="'board-list-box'"
        >
                <div class="board-list-header" v-if="!renameTitle" @click="enableEditName()">
                    <div class="board-cart-name text-word-break" placeholder="Column Title" >{{ column.name }}</div>
                </div>
                <div class="board-list-header" v-else>
                    <div class="board-cart-name">
                        <input v-model="column.name"
                               @blur="renameColumn($event)" />
                    </div>
                </div>

                <div class="board-list-cards">
                    <ColumnTask v-for="(task, $taskIndex) of column.tasks"
                                :key="$taskIndex"
                                :task="task"
                                :taskIndex="$taskIndex"
                                :column="column"
                                :columnIndex="columnIndex"
                                :board="board"
                                />
                    <div class="cards-edit-box"  v-if="!enableExtraClick">
                        <div class="edit-cards-start">
                            <textarea class="board-cart-textarea" placeholder="Card Title"
                                      ref="taskName"
                                      autofocus
                                      @keyup.enter="$event.target.blur()"
                                      @blur="createTask($event, column.tasks)"
                                      @keyup.esc="enableExtraClick = true"
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div class="board-add-card"
                     v-if="enableExtraClick"
                     >
                    <a @click="addNewTaskTx()">
                        <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#6E7077" d="M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5 11H7a1 1 0 010-2h10a1 1 0 110 2zm-5 5a1 1 0 01-1-1V7a1 1 0 012 0v10a1 1 0 01-1 1z"/>
                        </svg>
                        <span class="ml-2">Add a Card</span>
                    </a>
                </div>

                <div class="board-add-card">
                    <a @click="closeColumn(columnIndex)" v-if="! column.tasks.length" class="btn remove-column-btn btn-danger btn-sm mt-3">Remove Column</a>
                </div>
        </Drag>
    </Drop>
</template>

<script>
import ColumnTask from "./ColumnTask";
import Drag from "./Drag";
import Drop from "./Drop";
import MovingPlannerItems from "../../mixins/MovingPlannerItems";
export default {
    name: "BoardColumn",
    components: {
        ColumnTask,
        Drag,
        Drop
    },
    props: ['column'],
    data: () => {
        return {
            enableExtraClick: true,
            renameTitle: false,
        };
    },
    mixins: [MovingPlannerItems],
    methods: {
        createTask (e, tasks) {
            if(e.target.value) {
                this.$store.commit('CREATE_TASK', {
                    tasks,
                    name: e.target.value
                })
                e.target.value = ''

                this.enableExtraClick = true;
            } else {
                this.enableExtraClick = true;
                return false;
            }
        },

        addNewTaskTx () {
            this.enableExtraClick = false;
            setTimeout(() => {
                this.$refs.taskName.focus()
            })
        },

        closeColumn(columnIndex) {
            if(this.column.tasks.length < 1) {
                this.$store.commit('REMOVE_COLUMN', {
                    columnIndex
                })
            }
        },

        enableEditName() {
            this.renameTitle = true;
        },

        renameColumn(e) {
            this.$store.commit('UPDATE_COLUMN_NAME', {
                columnIndex: this.columnIndex,
                value: e.target.value,
            })
            this.renameTitle = false;
        }


    }
}
</script>

<style scoped>
.board-list-header input {
    border: 0;
    font-size: 25px;
    font-weight: 700;
    font-family: "Fira Sans", sans-serif;
    background: transparent;
    border-radius: 0;
    max-height: 256px;
    min-height: 30px;
    padding: 0;
    display: block;
    width: 100%;
    caret-color: #1E73BD;
}

</style>
